import { render, staticRenderFns } from "./CulturaView.vue?vue&type=template&id=1a2fadda&"
import script from "./CulturaView.vue?vue&type=script&lang=ts&"
export * from "./CulturaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports